<script setup lang="ts">
import { FdxButton } from '@foodics/ui-common';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
// import LocalisationsSwitcher from '@/components/LocalisationsSwitcher.vue';
// import { useLocale } from '@/composables/locale';

const router = useRouter();
function navigateToLogin() {
    router.push('/login');
}

const route = useRoute();
const showSignInButton = computed(() => {
    return route.meta.showSignInButton ?? false;
});

// const { enabled: localisationsEnabled } = useLocale();
</script>

<template>
    <div class="flex gap-x-2 px-4 py-2">
        <div class="flex gap-x-2">
            <div
                class="size-8 flex items-center justify-center bg-primary-500 rounded-md flex-shrink-0"
            >
                <FdxIconAccountBalance class="size-6 text-white" />
            </div>
            <span class="font-bold text-title-3 capitalize">
                {{ $t('generic.common_terms.bank') }}
            </span>
        </div>

        <div class="ms-auto flex flex-row-reverse gap-x-2">
            <!-- <LocalisationsSwitcher v-if="localisationsEnabled" /> -->

            <p v-if="showSignInButton">
                {{ $t('auth.have_an_account') }}

                <FdxButton
                    variant="secondary"
                    size="sm"
                    class="ms-2"
                    @click="navigateToLogin"
                >
                    {{ $t('generic.forms.signin') }}
                </FdxButton>
            </p>
        </div>
    </div>
</template>
